import { matchIsValidTel } from 'mui-tel-input';
import { AsYouType, parsePhoneNumberFromString } from 'libphonenumber-js';
import { PASSWORD_POLICY_REGEX } from './regex';

const DEFAULT_PHONE_COUNTRY = 'US' as const;

const hasNationalNumber = (value: string): boolean => {
  const asYouType = new AsYouType(DEFAULT_PHONE_COUNTRY);
  asYouType.input(value);
  return !!asYouType.getNumber()?.nationalNumber;
};

export const isValidPhoneNumber = (value?: string) => {
  const trimmed = value?.trim();
  if (!trimmed) return true;

  if (!hasNationalNumber(trimmed)) return true;

  const e164 = parsePhoneNumberFromString(trimmed, DEFAULT_PHONE_COUNTRY)?.number;
  return !!e164 && matchIsValidTel(e164);
};

export const toE164 = (value?: string): string | undefined => {
	const trimmed = value?.trim();
	if (!trimmed) return value;

  if (!hasNationalNumber(trimmed)) return "";

  if (!trimmed.startsWith("+")) return trimmed;

	return parsePhoneNumberFromString(trimmed, DEFAULT_PHONE_COUNTRY)?.number ?? value;
};

export const findRequiredFields = (prefix: string, fields: any) => {
	return Object.keys(fields).reduce((prev: any, current: string) => {
		if (fields[current].tests?.findIndex(({ name }: any) => name === 'required') >= 0) {
			prev[prefix ? prefix + '.' + current : current] = true;
		}
		if (fields[current].fields) {
			const nested = findRequiredFields(current, fields[current].fields);
			prev = { ...prev,  ...nested };
		}
		return prev;
	}, {});
};

export const validatePasswordPolicy = (password: string) => {
  return {
    hasMinLength: PASSWORD_POLICY_REGEX.MIN_LENGTH.test(password),
    hasUppercase: PASSWORD_POLICY_REGEX.UPPERCASE.test(password),
    hasLowercase: PASSWORD_POLICY_REGEX.LOWERCASE.test(password),
    hasNumber: PASSWORD_POLICY_REGEX.NUMBER.test(password),
    hasSpecialChar: PASSWORD_POLICY_REGEX.SPECIAL_CHAR.test(password),
    isValid: 
      PASSWORD_POLICY_REGEX.MIN_LENGTH.test(password) &&
      PASSWORD_POLICY_REGEX.UPPERCASE.test(password) &&
      PASSWORD_POLICY_REGEX.LOWERCASE.test(password) &&
      PASSWORD_POLICY_REGEX.NUMBER.test(password) &&
      PASSWORD_POLICY_REGEX.SPECIAL_CHAR.test(password)
  };
};